import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';


/**
 * A simple InputOrderFormCheckbox.
 */


class InputOrderFormCheckbox extends React.Component {
	constructor(props) {
	  super(props);
		this.handleClick = this.handleClick.bind(this);
	  this.state = {active:false, init:false};
	}
	componentDidMount() {
		if(this.props.selected) {
			this.setState({active:true});
		}
		this.setState({init:true});
	}


	handleClick(e) {
		var nextState = !this.state.active;
		this.setState({active:!this.state.active});
		this.props.onClick(this.props.itemkey, nextState);
	}

    render () {
        return (
          <div className={`orderformcheckbox${this.state.active?" selected":""}`}>
            <div className="toggler">
            	<div className="toggleselect" onClick={this.handleClick}><Icon filename="selected" /></div>
            </div>
            <div className="inner">
            	<div className="desc" onClick={this.handleClick}>
            		<h4>{this.props.label}</h4>
            	</div>
            </div>
            
          </div>
        );
    }

}


InputOrderFormCheckbox.propTypes = {
	/** InputOrderFormField Label */
	label: PropTypes.string.isRequired,
	/** InputOrderFormCheckbox selected */
	selected: PropTypes.bool,
}


InputOrderFormCheckbox.defaultProps = {
  selected: false,
}

export default InputOrderFormCheckbox;



// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormCheckbox.js